import { GenericModel } from "../../../generic.model";
import { makeModel } from "../../../../service/utils/utils.service";
import { NameModel } from "../../dataList/station/name.model";
import { KeywordModel } from "../../common/keyword.model";


export class ServiceModel extends GenericModel {
    public afid: string;
    public code: string;
    public id: string;
    public keywordArray: KeywordModel[];
    public nameArray: NameModel[];
    public xCategory: string;
    public xId: string;
    public xScope: string;
    // TODO public sectorArray: [{xRef: "SVH.1"}]
    // TODO public traveller: {xRef: "T.1"}
    // TODO public vehicleArray: [{xRef: "VH.16"}]
    // TODO public vehicleRentalArray: [{xRef: "SVH.1"}]
    // TODO public vendor: {code: "AL", name: {value: "ALAMO", languageCode: "en"}}

    public get name(): string {
        return this.nameArray[0].value;
    }

    protected fromJson(json?: any): boolean {
        this.afid = json.afid ?? null;
        this.code = json.code ?? null;
        this.id = json.id ?? null;
        this.keywordArray = makeModel(json.keywordArray, KeywordModel);
        this.nameArray = makeModel(json.nameArray, NameModel);
        this.xCategory = json.xCategory ?? null;
        this.xId = json.xId ?? null;
        this.xScope = json.xScope ?? null;
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.xId !== null && this.nameArray && this.nameArray.length > 0;
    }
}